import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { useNotifications } from '../../../contexts/NotificationContext';
import './Dashboard.css';
import './PageHeader.css';
import Sidebar from '../Sidebar/Sidebar';

// Dashboard Views
import DashboardHome from '../DashboardHome/DashboardHome';
import MyAuction from '../MyAuctions/MyAuctions';
import NewAuction from '../NewAuction/NewAuction';
import MyCreatedAuctionView from '../MyCreatedAuctions/MyCreatedAuctionView';
import ParticipantAuctionView from '../ParticipantAuctions/ParticipantAuctionView';
import JoinAuction from '../JoinAuction/JoinAuction';
import MyProfile from '../MyProfile/MyProfile';
import Plans from '../Plans/Plans';
import AuctionReports from '../AuctionReports/AuctionReports';
import DashboardHeader from './DashboardHeader';
import Separate_MyCreated from '../Separate_MyCreated/MyCreatedA';
import Separate_MyParticipat from '../Separate_MyParticipant/MyParticipantA';
import SharedAuctions from '../SharedAuctions/SharedAuctions';
import SharedAuctionLiveView from '../SharedAuctions/SharedAuctionLiveView';

// Participant Components
import ParticipantAuctionSession from '../../Participant/AuctionSession/ParticipantAuctionSession';

// Auctioneer Components
import AuctioneerLiveView from '../../Auctioneer/LiveAuction/AuctioneerLiveView';

// Test Components
import TimersAPITest from '../../TimersAPITest/TimersAPITest';

const Dashboard: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { user, syncProfile } = useAuth();

  // The role is cached in localStorage at login, so an admin promoting (or
  // revoking) this user as a channel partner would otherwise not show up
  // until they signed in again. Re-read it whenever the dashboard opens.
  useEffect(() => {
    syncProfile();
  }, []);

  // A company viewer (the 2nd auctioneer a channel partner attaches to an
  // auction) can only watch the auctions shared with them. Their routes are a
  // separate, minimal set so nothing else in the dashboard is reachable, even
  // by typing a URL. The API enforces the same limits independently.
  const isViewer = user?.role === 'auction_viewer';

  return (
    <div className="ap-dashboard">
      {/* Mobile sidebar backdrop */}
      {isSidebarOpen && (
        <div
          className="ap-dashboard-backdrop"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      {/* Sidebar Component */}
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

      {/* Main content */}
      <div className="ap-dashboard-main">
        {/* Top header */}
        <DashboardHeader
          onMenuClick={() => setIsSidebarOpen(true)}
          isSidebarOpen={isSidebarOpen}
        />

        {/* Page content */}
        <main className="ap-dashboard-content">
          {isViewer ? (
            <Routes>
              <Route path="shared" element={<SharedAuctions />} />
              <Route path="shared/:id" element={<SharedAuctionLiveView />} />
              <Route path="profile" element={<MyProfile />} />
              <Route path="*" element={<Navigate to="/dashboard/shared" replace />} />
            </Routes>
          ) : (
          <Routes>
            <Route path="shared" element={<SharedAuctions />} />
            <Route path="shared/:id" element={<SharedAuctionLiveView />} />
            <Route index element={<DashboardHome />} />
            <Route path="auctions" element={<MyAuction />} />
            <Route path="new-auction" element={<NewAuction />} />
            <Route path="edit-auction/:id" element={<NewAuction />} />
            <Route path="my-auction/:id" element={<MyCreatedAuctionView />} />
            <Route path="auction/:id" element={<ParticipantAuctionView />} />
            <Route path="join" element={<JoinAuction />} />
            <Route path="join/:id" element={<JoinAuction />} />
            <Route path="auction-session/:id" element={<ParticipantAuctionSession />} />
            <Route path="participant-auction/:id" element={<ParticipantAuctionSession />} />
            <Route path="auctioneer-live/:id" element={<AuctioneerLiveView />} />
            <Route path="profile" element={<MyProfile />} />
            <Route path="plans" element={<Plans />} />
            <Route path="reports" element={<AuctionReports />} />
            <Route path="timers-test" element={<TimersAPITest />} />
            <Route path="MyCreatedA" element={<Separate_MyCreated />} />
            <Route path="MyParticipatedA" element={<Separate_MyParticipat />} />
          </Routes>
          )}
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
